module.exports = __webpack_public_path__ + "static/media/NotoSans-Regular-Italic.0c18a06c.eot";